import { render, staticRenderFns } from "./nuevaCategoria.vue?vue&type=template&id=3b383e1c&scoped=true&lang=html&"
import script from "./nuevaCategoria.vue?vue&type=script&lang=js&"
export * from "./nuevaCategoria.vue?vue&type=script&lang=js&"
import style0 from "./nuevaCategoria.vue?vue&type=style&index=0&id=3b383e1c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b383e1c",
  null
  
)

export default component.exports